<template>
  <div class="project-category">
    <h1>Projets personnels</h1>
    <section class="projects-section" 
    v-for="project in projects" 
    :key="project.id">
          <!-- Featured Project Row dynamically generated -->
      <div class="project-layout">
        <img class="project-img" :src="project.img" :alt="project.name">
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data () {
    return {
      projects: [
        { 
          img: require('@/assets/projets-personnels/projet1.png')
        },
        { 
          img: require('@/assets/projets-personnels/projet2.jpg')
        },
        { 
          img: require('@/assets/projets-personnels/projet3.jpg')
        },
      ]
    }
  },
}
</script>




